import { FC, memo } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import type { Citation } from '@frontend/task-center-scope';
import { isValidSourceId } from '../../../utils';
import { CallIntelCitation } from './call-intel-citation';
import { MessageCitation } from './message-citation';

// TODO: make this type using partial values of type Task. i.e. sourceID and source
interface TaskCitationProps {
  source?: TaskCenterTypes.TaskSource;
  sourceId?: string;
  citation?: Citation;
  locationId: string;
  taskId: string;
  isTaskDeleted: boolean;
}

export const TaskCitation: FC<TaskCitationProps> = memo(
  ({ source, sourceId, citation, locationId, taskId, isTaskDeleted }) => {
    const isValidSource = isValidSourceId(sourceId);

    if (!isValidSource || !locationId) return null;

    switch (source) {
      case TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE:
        return <CallIntelCitation locationId={locationId} citation={citation} sourceId={sourceId} taskId={taskId} />;
      case TaskCenterTypes.TaskSource.SOURCE_MESSAGING:
        return (
          <MessageCitation
            locationId={locationId}
            sourceId={sourceId}
            citation={citation}
            isTaskDeleted={isTaskDeleted}
          />
        );
      default:
        return null;
    }
  }
);

TaskCitation.displayName = 'TaskCitation';
